import { inject, Injectable }                                               from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable }                                                       from 'rxjs';
import { TaxDocumentsService }                                              from '../../api/tax-documents/tax-documents.service';
import { map }                                                              from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TaxDocumentsGuard implements CanActivate {
  private taxDocumentsService = inject(TaxDocumentsService);
  private router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.taxDocumentsService
      .getTaxDocumentCustomers()
      .pipe(map(customersList => {
        const allowNavigation = customersList.length > 0;
        if (!allowNavigation) {
          this.router.navigate(['/error/404']);
        }
        return allowNavigation;
      }));
  }
}
